export default __webpack_public_path__ + "static/media/s_wdt_c_3.1557b39f.mp3";